<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
    :is-label-error="isError"
  >
    <slot name="before"></slot>
    <b-datetimepicker
      :id="forId"
      v-bind="$attrs"
      :class="[classAttr, {'text-center': isInline, 'is-danger': isError}]"
      icon="calendar-today"
      :icon-right="clearIcon"
      :icon-right-clickable="isClearable"
      @icon-right-click="clearDate"
      size="is-small"
      :inline="isInline"
      expanded
      :append-to-body="appendToBody"

      :value="date"
      :min-datetime="minDate"
      :max-datetime="maxDate"
      :range="isRange"

      :timepicker="{
        'locale': this.locale,
        'hour-format': this.hourFormat
      }"
      :locale="locale"
      :date-formatter="dateFormatter"
      @input="handleInput"
    ></b-datetimepicker>
    <slot name="after"></slot>
  </form-field>
</template>

<script>
export default {
  name: "FormFieldDatetimePicker",
  props: {
    value: {
      type: [Array, String, Number, Boolean, Date]
    },
    label: {
      type: String,
    },
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    },
    validationErrors: {
      type: Array,
      default: () => []
    },
    isInline: {
      type: Boolean,
      default: false
    },
    isRange: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    classAttr: {
      type: String,
      default: ''
    },
    helpText: {
      type: String
    },
    isClearable: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      forId: this.$utils.generateClientId(),
      hourFormat: '12',
      locale: 'en-US'
    }
  },
  computed: {
    date() {
      if (this.value && ! this.isRange) {
        return new Date(this.value)
      }
    },
    clearIcon() {
      if (this.isClearable) return 'close';
      return null;
    }
  },
  methods: {
    dateFormatter(date) {
      return new Intl.DateTimeFormat(this.locale, { timezome: "UTC" }).format(date)
    },
    clearDate() {
      this.$emit('input', null);
      this.$emit('change', null);
      this.$emit('selected', null);
    },
    handleInput(date) {
      /*
        Don't convert to ISO string if the calendar used is a range type
        It won't allow us to convert the date date (buefy datepicker restriction/limitation)
        Do the conversion to ISO string on the parent component
       */
      if (! this.isRange && typeof date != 'object') {
        date = date.toISOString();
      }

      this.$emit('input', date);
      this.$emit('change', date);
      this.$emit('selected', date);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

::v-deep .datepicker.is-danger .input {
  border-color: $danger;
  color: $danger;
}
</style>
